<!--
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-07-14 15:11:33
 * @LastEditors: chen wei
 * @LastEditTime: 2020-07-22 10:34:55
-->
<template>
<div class="ctrlProcessWave">
  <canvas ref="canvas"></canvas>
</div>
</template>

<script>
import wave from './wave.js'
export default {
  name: 'WaveView',
  data() {
    return {
      canvas: 'canvas',
      init: false

    }
  },
  mounted() {
    if (!this.init) {
      this.init = wave.init(this.$refs.canvas)
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.ctrlProcessWave {
  width: 100%;

  canvas {
    width: 100%;
    height: 80px;
  }
}
</style>
